module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    关于我们|联系我们|联系客服|友情链接\n    "), _c('br'), _vm._v(" 京公网安备 11000002000088号|京ICP证070359号\n    "), _c('br'), _vm._v(" 互联网出版许可证编号新出网证(京)字150号|出版物经营许可证|网络文化经营许可证京网文[2014]2148-348号|违法和不良信息举报电话：4006561155\n    "), _c('br'), _vm._v(" Copyright © 2004 - " + _vm._s(_vm.date) + " " + _vm._s(_vm.siteInfo.SystemName) + " " + _vm._s(_vm.siteInfo.SystemDomain) + " 版权所有|消费者维权热线：4006067733经营证照\n    "), _c('br'), _vm._v(" 经营性网站备案中心可信网站信用评估网络警察提醒你诚信网站中国互联网举报中心网络举报APP下载\n    "), _c('br'), _vm._v(" "), (_vm.config.isProxy) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "right": "1%",
      "top": "20%",
      "line-height": "30px",
      "z-index": "2"
    }
  }, [_vm._v("\n        线上模式:\n        "), _c('el-switch', {
    attrs: {
      "active-text": "线上模式",
      "inactive-text": "线上模式"
    },
    model: {
      value: (_vm.config.isOnline),
      callback: function($$v) {
        _vm.config.isOnline = $$v
      },
      expression: "config.isOnline"
    }
  }), _vm._v(" "), _c('br'), _vm._v("代理模式:\n        "), _c('el-switch', {
    attrs: {
      "active-text": "代理模式",
      "inactive-text": "代理模式"
    },
    model: {
      value: (_vm.config.isProxy),
      callback: function($$v) {
        _vm.config.isProxy = $$v
      },
      expression: "config.isProxy"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd971bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/footer.vue
// module id = 571
// module chunks = 221